import {
  StakeCol,
  StakeWrapper,
  Icons,
  Icon,
  StakeTitle,
  StakeSubTitle,
  StakeLink,
  StakeFooter,
  StakeFooterItem,
} from './Styled'
import { useActiveWeb3React, useDTOPrice, useTVL, useRewardRate, useTotalSupply } from '../../hooks'
import config from '../../config.json'
import { useState, useEffect } from 'react'
import { formatNumber } from '../../utils'
import ParaLogo from '../../assets/images/para-logo-mobile.svg'

interface IStakeCardProps {
  poolId: number
}

function StakeCard(props: IStakeCardProps): JSX.Element {
  const [tvl, setTVL] = useState(0)
  const [dtoLocked, setDTOLocked] = useState(0)
  const [apy, setAPY] = useState(0)

  const { poolId } = props
  const { chainId } = useActiveWeb3React()
  const networkId = chainId ?? Number(process.env.REACT_APP_CHAIN_ID)

  const pool = config.pools[networkId].find(p => p.id === poolId)

  const totalSupplyCallback = useTotalSupply(pool?.contract)
  const rewardRateCallback = useRewardRate(pool?.contract)
  const dtoPriceCallback = useDTOPrice()
  const tvlCallback = useTVL(poolId)

  useEffect(() => {
    const fetchTotal = async () => {
      try {
        const _rewardRate = await rewardRateCallback()
        const _totalSupply = await totalSupplyCallback()
        const _tokenPrice = await dtoPriceCallback()
        if (poolId === 0) {
          setDTOLocked(_totalSupply)
          setTVL(_totalSupply * _tokenPrice)
          if (_totalSupply === 0) {
            setAPY(0)
          } else {
            setAPY(((_rewardRate * 86400 * 365) / _totalSupply) * 100)
          }
        } else {
          const _tvl = await tvlCallback()
          setTVL(_tvl)
        }
      } catch (error: any) {
        console.error(error)
      }
    }

    fetchTotal()
  }, [chainId])

  return (
    <StakeCol md={6} lg={4}>
      <StakeWrapper>
        <Icons>
          <Icon src={ParaLogo} alt="Paradiso" />
        </Icons>
        <StakeTitle>{pool.name}</StakeTitle>
        <StakeSubTitle>{pool.description ? `${pool.description}` : `Stake ${pool.symbol} to earn DTO}`}</StakeSubTitle>
        <StakeLink to={`/stake/${pool.slug}`}>Select</StakeLink>
        <StakeFooter>
          <StakeFooterItem>
            <span>DTO Locked</span>
            <span>{formatNumber(dtoLocked.toFixed(3))} DTO</span>
          </StakeFooterItem>
          <StakeFooterItem>
            <span>TVL</span>
            <span>{formatNumber(tvl.toFixed(3))} USD</span>
          </StakeFooterItem>
          <StakeFooterItem>
            <span>APY</span>
            <span>{formatNumber(apy.toFixed(3))} %</span>
          </StakeFooterItem>
        </StakeFooter>
      </StakeWrapper>
    </StakeCol>
  )
}

export default StakeCard
